import { watch, onUnmounted } from "vue";

// Bloquea el scroll del <body> mientras haya al menos un modal abierto.
// Usa un contador global para que, si se abre un modal sobre otro, el scroll
// recién se libere cuando se cierren todos (evita desbloquear de más).
let abiertos = 0;

function bloquear() {
  abiertos++;
  if (abiertos === 1) {
    document.body.style.overflow = "hidden";
  }
}

function liberar() {
  if (abiertos === 0) return;
  abiertos--;
  if (abiertos === 0) {
    document.body.style.overflow = "";
  }
}

// Recibe un ref/getter booleano: cuando es true bloquea el scroll, cuando es
// false lo libera. Se autolimpia si el componente se desmonta estando abierto.
export function useScrollLock(estaAbierto) {
  let bloqueadoPorEste = false;

  watch(
    estaAbierto,
    (abierto) => {
      if (abierto && !bloqueadoPorEste) {
        bloquear();
        bloqueadoPorEste = true;
      } else if (!abierto && bloqueadoPorEste) {
        liberar();
        bloqueadoPorEste = false;
      }
    },
    { immediate: true }
  );

  onUnmounted(() => {
    if (bloqueadoPorEste) {
      liberar();
      bloqueadoPorEste = false;
    }
  });
}
